import { DealStage, MeetingType } from '../api/generated';

/**
 * Pre-call Deal Stage / Meeting Type options, derived directly from the
 * generated API enums (single source of truth — the backend StrEnum). Order
 * follows the enum declaration order (sales-process order).
 */
export const DEAL_STAGES = Object.values(DealStage);
export const MEETING_TYPES = Object.values(MeetingType);

/** Guidance distinguishing the two fields. */
export const DEAL_STAGE_HELP = 'Where the opportunity sits in your overall sales process.';
export const MEETING_TYPE_HELP = 'The purpose of this specific call.';
/** Guides reps on what Company Size is for — it shapes how the AI tailors the approach. */
export const COMPANY_SIZE_HELP =
  'Headcount of the prospect company — helps the AI tailor messaging and approach (buying complexity, stakeholders, sales motion).';
